import { TimelineDataType } from './TimelineDataType';

export const timelineOptionsTypeInit = {
  minDate: '',
  maxDate: '',
  data: [] as TimelineDataType[],
};

export type TimelineOptionsType = typeof timelineOptionsTypeInit;
